/** ******************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2025
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} * */

import React, { useEffect, useState } from 'react';
import { TextInput } from '@carbon/react';
import { useTranslation } from 'react-i18next';

function TestToolScramShaAuth({ scramCreds, onChange }) {
  const [scramSessionId, setScramSessionId] = useState('');
  const [scramEncryptedCreds, setScramEncryptedCreds] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    setScramSessionId(scramCreds.scramSessionId ?? '');
    setScramEncryptedCreds(scramCreds.scramEncryptedCreds ?? '');
  }, [scramCreds.scramEncryptedCreds, scramCreds.scramSessionId]);

  const handleHttpScramSessionIdChange = (event) => {
    const scramSessionId = event.target.value;
    setScramSessionId(event.target.value);
    if (onChange && typeof onChange === 'function') {
      onChange({ scramEncryptedCreds, scramSessionId });
    }
  };

  const handleHttpScramEncryptedCredsChange = (event) => {
    const scramEncryptedCreds = event.target.value;
    setScramEncryptedCreds(event.target.value);
    if (onChange && typeof onChange === 'function') {
      onChange({ scramEncryptedCreds, scramSessionId });
    }
  };

  return (
    <div className="testToolScramShaAuth">
      <div className="scramsessionid">
        <div className="labelText">{t('session_identifier')}</div>
        <TextInput id="scramsessionid" hideLabel labelText={t('session_identifier')} value={scramSessionId} onChange={handleHttpScramSessionIdChange} />
      </div>

      <div className="scramencryptedcreds">
        <div className="labelText">{t('encrypted_creds')}</div>
        <TextInput
          id="scramencryptedcreds"
          labelText={t('encrypted_creds')}
          hideLabel
          value={scramEncryptedCreds}
          onChange={handleHttpScramEncryptedCredsChange}
        />
      </div>
    </div>
  );
}

export default TestToolScramShaAuth;
